<template>
  <b-form-group
    id="store-brand-branch"
    :class="formGroupClass"
    :style="cssStyle"
  >
    <template slot="label">
      {{ formGroupLabel }}
      <span class="text-danger" v-if="isRequired">*</span>
    </template>
    <b-dropdown
      id="brand-branch-dropdown"
      :text="brandAndBranchDropdownText"
      class="d-flex"
      variant="ghost"
      :toggle-class="[
        'text-left d-flex align-items-center justify-content-between border rounded pr-4 bg-white',
        {
          'disabled-dropdown': disabled || isLoading,
          'dropdown-toggle-bold':
            (isSingle && !!selectedBrandBranch) ||
            (!isSingle &&
              selectedBrandAndBranchUuids &&
              selectedBrandAndBranchUuids.length > 0 &&
              !isLoading &&
              !disabled),
          'dropdown-right': isDropRight,
        },
      ]"
      :menu-class="['w-100 p-0', { 'bypass-max-width': maxWidthBypass }]"
      :disabled="disabled"
      ref="brandsBranchesDropdownToggle"
      :dropright="isDropRight"
    >
      <template v-if="isShopIcon" slot="button-content">
        <img
          src="@/assets/images/icons/storefront.svg"
          alt="Branch"
          class="mr-1"
        />
        {{ brandAndBranchDropdownText }}
      </template>
      <b-form-group class="p-2 mb-0">
        <b-input-group>
          <template #prepend>
            <b-input-group-text
              class="border-0 search-brand-branch px-3"
            ></b-input-group-text>
          </template>
          <b-form-input
            class="border-0"
            placeholder="Search"
            autocomplete="off"
            v-model="name"
            @input="applySearch"
          ></b-form-input>
        </b-input-group>
      </b-form-group>
      <div
        class="branches-container"
        v-infinite-scroll="loadMoreBrandsBranches"
        :infinite-scroll-disabled="isLoading"
        :infinite-scroll-immediate-check="true"
        infinite-scroll-distance="50"
      >
        <div
          class="px-3 py-2"
          v-if="brandsAndBranches.length === 0 && !isLoading"
        >
          <small class="text-muted">No brands / branches found.</small>
        </div>
        <b-form-group
          class="mb-0"
          v-if="
            !isSingle && brandsAndBranches.length > 0 && !isLoading && !name
          "
        >
          <div class="px-3 py-2">
            <b-form-checkbox
              v-model="isSelectedAllStores"
              @input="checkAllBrandBranches"
            >
              <span class="offset-label">Select All</span>
            </b-form-checkbox>
          </div>
        </b-form-group>
        <div class="px-3 py-2" v-if="isLoading">
          <small class="text-muted">Loading...</small>
        </div>
        <template v-else>
          <b-form-group
            class="mb-0"
            v-for="(brand, brandIndex) in brandsAndBranches"
            :key="`brand-${brandIndex}`"
          >
            <div class="bg-light px-3 py-2">
              <template v-if="isSingle">
                <b-form-radio-group class="d-flex justify-content-between">
                  <b-button
                    variant="ghost"
                    class="border-0 rounded-0 p-0 cursor-pointer collapse-trigger"
                    v-b-toggle="`branches-${brandIndex}`"
                  >
                    <span class="when-open"
                      ><img
                        src="../../assets/images/caret-left-2.svg"
                        alt="caret-left"
                    /></span>
                  </b-button>
                  <span class="mt-1 ml-2 flex-grow-1">{{ brand.name }}</span>
                  <b-button
                    variant="ghost"
                    class="border-0 rounded-0 p-0 cursor-pointer collapse-trigger"
                    v-b-toggle="`branches-${brandIndex}`"
                  >
                    <span class="when-closed"
                      ><img
                        src="../../assets/images/caret-right-2.svg"
                        alt="caret-right"
                    /></span>
                  </b-button>
                </b-form-radio-group>
              </template>
              <template v-else>
                <b-form-checkbox-group
                  v-model="selectedBrandUuids"
                  class="d-flex justify-between"
                >
                  <b-button
                    variant="ghost"
                    class="border-0 rounded-0 p-0 cursor-pointer collapse-trigger"
                    v-b-toggle="`branches-${brandIndex}`"
                  >
                    <span class="when-open"
                      ><img
                        src="../../assets/images/caret-left-2.svg"
                        alt="caret-left"
                    /></span>
                  </b-button>
                  <b-form-checkbox
                    v-if="!name"
                    :value="brand.uuid"
                    class="mt-1 mb-0 flex-grow-1"
                    :ref="`branches-${brandIndex}`"
                    @change="handleAllBranches(brand.uuid)"
                  >
                    <span class="offset-label">{{ brand.name }}</span>
                    <div
                      class="offset-label text-primary"
                      v-if="countSelectedBranches(brand.uuid)"
                    >
                      {{
                        `${countSelectedBranches(brand.uuid)} Selected Branch${
                          countSelectedBranches(brand.uuid) > 1 ? "es" : ""
                        }`
                      }}
                    </div>
                  </b-form-checkbox>
                  <div v-else class="flex-grow-1">
                    <span class="mt-1 ml-2">{{ brand.name }}</span>
                    <div
                      class="ml-2 text-primary"
                      v-if="countSelectedBranches(brand.uuid)"
                    >
                      {{
                        `${countSelectedBranches(brand.uuid)} Selected Branch${
                          countSelectedBranches(brand.uuid) > 1 ? "es" : ""
                        }`
                      }}
                    </div>
                  </div>
                  <b-button
                    variant="ghost"
                    class="border-0 rounded-0 p-0 cursor-pointer collapse-trigger"
                    v-b-toggle="`branches-${brandIndex}`"
                  >
                    <span class="when-closed"
                      ><img
                        src="../../assets/images/caret-right-2.svg"
                        alt="caret-right"
                    /></span>
                  </b-button>
                </b-form-checkbox-group>
              </template>
            </div>
            <b-collapse :id="`branches-${brandIndex}`" class="px-3 py-2">
              <template v-if="isSingle">
                <b-form-radio-group v-model="selectedBrandBranch">
                  <template
                    v-for="(branch, branchIndex) in brand.branches"
                    class="py-2"
                  >
                    <b-form-radio
                      :value="{
                        branch_uuid: branch.uuid,
                        brand_uuid: brand.uuid,
                      }"
                      class="mt-1 mb-0 d-flex py-1"
                      :key="`branch-${branchIndex}`"
                    >
                      <span class="offset-label">{{ branch.name }}</span>
                    </b-form-radio>
                  </template>
                </b-form-radio-group>
              </template>
              <template v-else>
                <b-form-checkbox-group
                  v-model="selectedBrandUuids"
                  v-if="!name"
                >
                  <b-form-checkbox
                    :value="brand.uuid"
                    class="mt-1 mb-0 flex-grow-1"
                    @change="handleAllBranches(brand.uuid)"
                  >
                    <span class="offset-label">All Branches</span>
                  </b-form-checkbox>
                </b-form-checkbox-group>
                <b-form-checkbox-group v-model="selectedBrandAndBranchUuids">
                  <template
                    v-for="(branch, branchIndex) in brand.branches"
                    class="py-2"
                  >
                    <b-form-checkbox
                      :value="{
                        branch_uuid: branch.uuid,
                        brand_uuid: brand.uuid,
                      }"
                      class="mt-1 mb-0 d-flex py-1"
                      :key="`branch-${branchIndex}`"
                    >
                      <span class="offset-label">{{ branch.name }}</span>
                    </b-form-checkbox>
                  </template>
                </b-form-checkbox-group>
              </template>
            </b-collapse>
          </b-form-group>
        </template>
      </div>
      <div
        class="dropdown-buttons-container bg-white d-flex align-items-center justify-content-between py-2 px-3"
      >
        <b-button variant="ghost text-dark px-0" @click="clearSelected">
          Clear Selected
        </b-button>
        <b-button variant="primary" pill class="px-4" @click="applySelected">
          Apply
        </b-button>
      </div>
    </b-dropdown>
    <b-form-invalid-feedback :force-show="isInvalid(errorKey)">
      {{ errorMessage(errorKey) }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import _ from "lodash";
const infiniteScroll = require("vue-infinite-scroll");

export default {
  name: "BrandBranchesComponent",
  props: {
    disabled: Boolean,
    errorKey: String,
    brandAndBranchUuids: Array,
    isDropRight: {
      type: Boolean,
      default: false,
    },
    isAllSelected: {
      type: Boolean,
      default: false,
    },
    formGroupLabel: {
      type: String,
      default: "Brand & Branch",
    },
    formGroupClass: String,
    isSingle: Boolean,
    brandBranch: Object,
    bypassMaxWidth: Boolean,
    isShopIcon: Boolean,
    allSelectedDropdownText: String,
    isRequired: Boolean,
    maxWidthBypass: Boolean,
  },
  data() {
    return {
      name: null,
      page: 0,
      selectedBrandAndBranchUuids: [],
      selectedBrandUuids: [],
      isSelectedAllStores: false,
      init: false,
      brandAndBranchDropdownText: "Select",
      selectedBrandBranch: null,
    };
  },
  computed: {
    ...mapState("employees", ["errors"]),
    ...mapGetters({
      branches: "branches/originalBranches",
      brands: "brands/brands",
      brandsAndBranches: "orderFulfillment/brands_branches",
      storedBrandAndBranches: "orderFulfillment/stored_brands_branches",
      brandAndBranchesMaxPage: "orderFulfillment/brand_branches_max_page",
      isLoading: "orderFulfillment/loading_branches",
    }),
    branchesByBrands: {
      get() {
        const branchesByBrands = {};
        if (this.brandsAndBranches.length > 0) {
          this.brandsAndBranches.map((brand) => {
            branchesByBrands[`${brand.uuid}`] = brand.branches;
          });
        }
        return branchesByBrands;
      },
      set(value) {
        return value;
      },
    },
    cssStyle: {
      get() {
        return {
          "--max-width": this.bypassMaxWidth ? null : "372px",
        };
      },
      set(style) {
        return style;
      },
    },
  },
  mounted() {
    this.$root.$on("clearSelectedBrandsAndBranches", () => {
      this.clearSelected();
      this.formatDropdownText();
    });
    this.$root.$on("bv::toggle::collapse", (id) => {
      if (id.includes("branches")) {
        const findBranches = document.getElementById(id);
        setTimeout(() => {
          if (
            this.$refs[id] &&
            this.$refs[id].length > 0 &&
            findBranches.classList.value.includes("show")
          ) {
            this.$nextTick(() => {
              this.$refs[id][0].$el.classList.add("collapsed-checkbox");
            });
          } else {
            this.$nextTick(() => {
              if (this.$refs[id] && this.$refs[id].length > 0)
                this.$refs[id][0].$el.classList.remove("collapsed-checkbox");
            });
          }
        }, 400);
      }
    });
  },
  async created() {
    this.$store.dispatch("brands/getBrands");
    await this.initBranches();

    this.selectedBrandAndBranchUuids = this.brandAndBranchUuids;
    this.formatDropdownText();
    this._applySearch = _.debounce(() => {
      this.page = 0;
      this.loadMoreBrandsBranches(true);
    }, 400);

    if (this.isAllSelected) {
      this.isSelectedAllStores = true;
      this.checkAllBrandBranches(true);
      this.formatDropdownText();
    }
  },
  methods: {
    ...mapActions({
      getBrandsBranches: "orderFulfillment/getBrandsBranches",
    }),
    async initBranches() {
      this.init = true;
      this.page = this.page + 1;
      const request = {
        init: true,
        reset: true,
        param: {
          page: this.page,
          payload: {
            name: this.name,
          },
        },
      };
      await this.getBrandsBranches(request);
      this.checkIsAllBranches();
      this.init = false;
    },
    checkAllBrandBranches(value) {
      if (value) {
        Object.keys(this.branchesByBrands).forEach((brand) => {
          this.selectedBrandUuids.push(brand);
        });
      } else this.selectedBrandAndBranchUuids = [];
    },
    checkIsAllBranches() {
      if (
        !this.isLoading &&
        this.selectedBrandAndBranchUuids &&
        this.selectedBrandAndBranchUuids.length > 0
      ) {
        const groupedByBranchUuid = _.groupBy(
          this.selectedBrandAndBranchUuids,
          "brand_uuid"
        );
        const brandUuids = this.brandsAndBranches.map((brand) => brand.uuid);
        Object.keys(groupedByBranchUuid).forEach((brand) => {
          if (
            brandUuids.includes(brand) &&
            groupedByBranchUuid[brand].length ===
              this.branchesByBrands[brand].length &&
            !this.selectedBrandUuids.includes(brand)
          ) {
            this.selectedBrandUuids.push(brand);
          } else if (
            brandUuids.includes(brand) &&
            this.selectedBrandUuids.includes(brand) &&
            groupedByBranchUuid[brand].length !==
              this.branchesByBrands[brand].length
          ) {
            const brandIndex = this.selectedBrandUuids.indexOf(brand);
            this.$nextTick(() => {
              this.selectedBrandUuids.splice(brandIndex, 1);
              this.$nextTick(() => {
                this.isSelectedAllStores = false;
              });
            });
          }
        });
      }
    },
    handleAllBranches(brandUuid) {
      this.$nextTick(() => {
        if (!this.selectedBrandUuids.includes(brandUuid)) {
          const branches = this.brandsAndBranches.find(
            (item) => item.uuid === brandUuid
          ).branches;
          branches.map((branch) => {
            const branchIndex = this.selectedBrandAndBranchUuids.findIndex(
              ({ brand_uuid, branch_uuid }) =>
                brand_uuid === branch.brand_uuid && branch_uuid === branch.uuid
            );
            this.selectedBrandAndBranchUuids.splice(branchIndex, 1);
          });
        }
      });
    },
    clearSelected() {
      this.selectedBrandUuids = [];
      this.selectedBrandAndBranchUuids = [];
      this.isSelectedAllStores = false;
      this.selectedBrandBranch = {};
    },
    formatDropdownText() {
      if (!this.isSingle) {
        if (this.isSelectedAllStores && this.allSelectedDropdownText) {
          this.brandAndBranchDropdownText = this.allSelectedDropdownText;

          return;
        }

        const selectedBrandUuids = [
          ...new Set(
            this.selectedBrandAndBranchUuids.map(({ brand_uuid }) => brand_uuid)
          ),
        ];
        const selectedBrands = this.brands.filter(({ uuid }) =>
          selectedBrandUuids.includes(uuid)
        );
        const brandAndBranchDropdownContents = selectedBrands.map(
          ({ name, uuid }) => {
            const branchCount = this.selectedBrandAndBranchUuids.filter(
              ({ brand_uuid }) => brand_uuid === uuid
            ).length;

            return `${name} - ${branchCount} Branch${
              branchCount > 1 ? "es" : ""
            } Selected`;
          }
        );

        this.brandAndBranchDropdownText = brandAndBranchDropdownContents.length
          ? brandAndBranchDropdownContents.sort().join(", ")
          : "Select";
      } else if (
        this.isSingle &&
        !_.isEmpty(this.selectedBrandBranch) &&
        this.branches.length > 0
      ) {
        const { brand_name, name } = this.branches.filter(
          (branch) => branch.uuid === this.selectedBrandBranch.branch_uuid
        )[0];
        this.brandAndBranchDropdownText = `${brand_name} - ${name}`;
      } else this.brandAndBranchDropdownText = "Select";
    },
    isInvalid(key) {
      return this.errors && this.errors[key] ? true : false;
    },
    errorMessage(key) {
      return this.errors && this.errors[key]
        ? this.errors[key].split(".").join(" ")
        : null;
    },
    async loadMoreBrandsBranches(reset = false) {
      this.page = this.page + 1;
      const request = {
        reset: reset,
        param: {
          page: this.page,
          payload: {
            name: this.name,
          },
        },
      };
      if (!this.isLoading && !this.brandAndBranchesMaxPage)
        await this.getBrandsBranches(request);
      else if (this.page <= this.brandAndBranchesMaxPage && !this.isLoading)
        await this.getBrandsBranches(request);
      this.checkIsAllBranches();

      if (this.isSelectedAllStores) this.checkAllBrandBranches(true);
    },
    applySearch() {
      this._applySearch();
    },
    countSelectedBranches(brandUuid) {
      return (
        this.selectedBrandAndBranchUuids.length &&
        this.selectedBrandAndBranchUuids.filter(
          ({ brand_uuid }) => brand_uuid === brandUuid
        ).length
      );
    },
    onDropdownHide() {
      this.name = null;
      if (!this.isSingle) {
        this.$emit(
          "applyBrandsAndBranches",
          this.selectedBrandAndBranchUuids,
          this.isSelectedAllStores
        );
      } else {
        this.$emit("applyBrandsAndBranches", this.selectedBrandBranch);
      }
      this.formatDropdownText();
    },
    applySelected() {
      this.onDropdownHide();
      this.$refs.brandsBranchesDropdownToggle.hide();
    },
  },
  watch: {
    selectedBrandAndBranchUuids: {
      deep: true,
      handler(branches) {
        this.checkIsAllBranches();
        if (branches && branches.length === 0) this.selectedBrandUuids = [];
      },
    },
    selectedBrandUuids(brands) {
      const brandUuids = this.brandsAndBranches.map((brand) => brand.uuid);
      brands.map((brand) => {
        if (brandUuids.includes(brand)) {
          this.brandsAndBranches
            .find((item) => item.uuid == brand)
            .branches.map((branch) => {
              const checkBranches = this.selectedBrandAndBranchUuids.map(
                (item) => item.branch_uuid
              );
              if (!checkBranches.includes(branch.uuid))
                this.selectedBrandAndBranchUuids.push({
                  branch_uuid: branch.uuid,
                  brand_uuid: brand,
                });
            });
        }
      });
    },
    isLoading(isLoading) {
      if (isLoading) this.brandAndBranchDropdownText = "Loading...";
      else this.brandAndBranchDropdownText = "Select";
    },
    brandAndBranchUuids() {
      this.selectedBrandAndBranchUuids = this.brandAndBranchUuids;
      if (this.brandAndBranchUuids.length === 0)
        this.brandAndBranchDropdownText = "Select";
    },
    brandBranch(brandBranch) {
      this.selectedBrandBranch = brandBranch;
      this.formatDropdownText();
    },
  },
  directives: { infiniteScroll },
};
</script>

<style lang="scss">
#store-brand-branch {
  #brand-branch-dropdown {
    max-width: var(--max-width);
    .dropdown-toggle {
      color: #68737d;
      position: relative;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block !important;
      &::after {
        position: absolute;
        right: 10px;
        top: 12px;
        height: 11px;
        width: 12px;
        background: url("~@/assets/images/dropdown.svg") no-repeat center;
        border: 0;
      }
      &.disabled-dropdown {
        background: #e9ebed;
        cursor: not-allowed;
      }
      &.dropdown-toggle-bold {
        font-family: MainFontBold, sans-serif;
        color: #2f3941;
      }
      &.dropdown-right::after {
        background: url("~@/assets/images/caret-right-2.svg") no-repeat center;
      }
    }
    .dropdown-menu {
      border: 0;
      box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
      border-radius: 5px;
      overflow: hidden;
      max-width: 372px;
      & > .branches-container {
        max-height: 300px;
        overflow-y: auto;
        border-top: 1px solid #dee2e6;
        padding-top: 10px;
      }
      &.bypass-max-width {
        max-width: inherit;
      }
    }
    .search-brand-branch {
      background: url("../../assets/images/search.svg") no-repeat center;
    }
    .collapsed-checkbox > .custom-control-label::before,
    .collapsed-checkbox > .custom-control-label::after,
    .collapsed-checkbox > .custom-control-input {
      display: none !important;
    }
    .collapsed-checkbox > .custom-control-label {
      text-indent: -10px;
    }
    .dropdown-buttons-container {
      .btn.btn-primary {
        border-radius: 20px;
      }
    }
    .text-dark {
      color: #87929d !important;
    }
  }
  .invalid-feedback {
    font-size: 10.4px;
  }
}
</style>

<style lang="scss" scoped>
.offset-label {
  position: relative;
  top: -3px;
}
.collapse-trigger.collapsed > .when-open {
  display: none;
}
.collapse-trigger:not(.collapsed) > .when-closed {
  display: none;
}
</style>